<div>
  @if (singleListLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (singleListError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div>
      <div class="overflow-x-auto">
        <table
          mat-table
          [dataSource]="dataSource"
          [matSortActive]="currentSort.active"
          [matSortDirection]="currentSort.direction"
          matSort
          (matSortChange)="sortData($event)"
          class="w-full"
        >
          <!-- Job # Column -->
          <ng-container matColumnDef="orderId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Job #
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.orderId }}
            </td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Description
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">{{ order.description }}</td>
          </ng-container>

          <!-- Client PO # Column -->
          <ng-container matColumnDef="clientPurchaseOrder">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Client PO #
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.clientPurchaseOrder }}
            </td>
          </ng-container>

          <!-- CA # Column -->
          <ng-container matColumnDef="caNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              CA #
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.caNumber?.caNumber }}
            </td>
          </ng-container>

          <!-- Due Date Column -->
          <ng-container matColumnDef="promisedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Due Date
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.dueDate | date: CONFIG.date.dueDateFormat }}
            </td>
          </ng-container>

          <!-- Created Column -->
          <ng-container matColumnDef="dateCreated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Created
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.dateCreated | date: CONFIG.date.createdDateFormat }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Status
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.status }}
            </td>
          </ng-container>

          <!-- Client Column -->
          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Client
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.client.code }}
            </td>
          </ng-container>

          <!-- Assignee Column -->
          <ng-container matColumnDef="assignee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Assignee
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{
                order.assignee ? order.assignee.firstName + ' ' + order.assignee.lastName : 'N/A'
              }}
            </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="totalQuantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Quantity
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.totalQuantity }}
            </td>
          </ng-container>

          <!-- Total Price Column -->
          <ng-container matColumnDef="orderTotalPrice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Total Price
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.orderTotalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
            </td>
          </ng-container>

          <!-- Total Price Not Shipped Column -->
          <ng-container matColumnDef="orderTotalPriceNotShipped">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Total Price Not Shipped
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">N/A</td>
          </ng-container>

          <!-- Last Edited Column -->
          <ng-container matColumnDef="dateUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Last edited
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.dateUpdated | date: CONFIG.date.createdDateFormat }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="border-b p-4 text-right w-24"
            ></th>
            <td mat-cell *matCellDef="let order" class="border-b p-4 text-right">
              <div class="invisible group-hover:visible flex items-center justify-end gap-2">
                <button
                  mat-icon-button
                  matTooltip="Archive Order"
                  class="text-gray-700"
                  [ngClass]="{ '!text-red-500': order.isPastDue }"
                >
                  <mat-icon>archive</mat-icon>
                </button>
                <button
                  mat-icon-button
                  matTooltip="Edit Order"
                  [routerLink]="['/orders', order.id, 'edit']"
                  (click)="$event.stopPropagation()"
                  class="text-gray-700"
                  [ngClass]="{ '!text-red-500': order.isPastDue }"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ '!text-red-500': row.isPastDue }"
            [routerLink]="['/orders', row.id, 'view']"
            class="hover:bg-gray-100 cursor-pointer order-row group"
          ></tr>
        </table>
        <div
          *ngIf="!singleListLoading() && !singleListError() && dataSource.data.length === 0"
          class="text-center text-gray-500 py-8"
        >
          There are no records available.
        </div>
      </div>

      <ng-container *ngIf="dataSource.data.length !== 0">
        <ciwc-pagination
          [currentPage]="pageIndex"
          [pageSize]="pageSize"
          [totalItems]="singleList()?.results?.noTotal || 0"
          [pageSizeOptions]="pageSizeOptions"
          (pageChange)="handlePageEvent($event)"
        ></ciwc-pagination>

        <!-- Hidden paginator for functionality -->
        <div class="hidden">
          <mat-paginator
            #paginator
            [length]="singleList()?.results?.noTotal || 0"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="handlePageEvent($event)"
            aria-label="Select page"
          >
          </mat-paginator>
        </div>
      </ng-container>
    </div>
  }
</div>
